import React, { useState, useEffect } from 'react';
import '../../styles/profileStyles/ProfilePage.css';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/HeaderFooter/Header';
import Footer from '../../components/HeaderFooter/Footer';
import 'react-datepicker/dist/react-datepicker.css';
import { fetchUserData } from '../../services/API';

const ProfilePage = () => {
  const [activeTab, setActiveTab] = useState('My Profile');
  const [adminData, setAdminData] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null); // State for selected employee
  const [employees, setEmployees] = useState([]); // State for employee list
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchUserData();
        const loggedInEmail = localStorage.getItem('loggedInUserEmail');
        const currentAdmin = response.data.find(user => user.Email === loggedInEmail);
        setAdminData(currentAdmin);
       
        // Assuming the API returns all users, including employees
        setEmployees(response.data.filter(user => user.Email !== loggedInEmail));
        if (location.state && location.state.employee) {
          setSelectedEmployee(location.state.employee);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchData();
  },[location.state]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === 'Employees') {
      navigate('/employeeslist');
    }
  };

  const handleEditClick = () => {
    // navigate('/newemployee', { state: { profileData } }); 
    navigate('/newemployee', { state: { profileData: selectedEmployee || adminData } });
  };

  const handleEmployeeClick = (employee) => {
    setSelectedEmployee(employee); // Set selected employee to display their profile
  };

  const profileData = selectedEmployee || adminData; 

  if (!profileData) {
    return <div>Loading...</div>;
  }
  
  const profileImagePath = `http://localhost:3000/${profileData.Picture_File_Path}`;
  
  console.log("Picture path " , profileImagePath);

  return (
    <div className="profile-container">
      <Header />
      <div className="profile-content">
        <div className="profile-tabs-container">
          <h2 className="profile-tabs-title">Profile</h2>
          <div className="profile-tabs">
            <button
              className={`profile-tab-item ${activeTab === 'My Profile' ? 'active' : ''}`}
              onClick={() => {
                setSelectedEmployee(null); // Reset to admin profile
                handleTabClick('My Profile');
              }}
            >
              My Profile
            </button>
            <button
              className={`profile-tab-item ${activeTab === 'Employees' ? 'active' : ''}`}
              onClick={() => handleTabClick('Employees')}
            >
              Employees
            </button>
          </div>
        </div>

        {activeTab === 'Employees' && (
          <div className="employees-list">
            {employees.map(employee => (
              <div
                key={employee.Email} // Assuming Email is unique
                onClick={() => handleEmployeeClick(employee)}
                className="employee-item"
              >
                {employee.First_Name} {employee.Last_Name}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="profileScreen">
        <div className="profile-card">
          <div className="profile-image-container">
            <img src={profileImagePath} alt="" className="profile-image" />
            
          </div>
          <div className="profile-name">{profileData.First_Name} {profileData.Last_Name}</div>
        </div>
        <div className="profile-header">
          <h3 className="descript">Profile Description</h3>
          <div className="profile-details">
          <div className="profile-details-header">
          <h3 className="profile-title">Profile Details</h3>
          <button className="prof-edit-button" onClick={handleEditClick}>
          <img src="/images/edit.png" alt="Edit Icon" className="prof-edit-icon" />
    <span>Edit</span>

  </button>
</div>
            <div className="profile-details-container">
              <table className="profile-table">
                <tbody>
                  <tr>
                    <td><strong>First Name</strong><br/><br/>{profileData.First_Name}</td>
                    <td><strong>Last Name</strong><br/><br/>{profileData.Last_Name}</td>
                    <td><strong>Birthday</strong><br/><br/>{profileData.Birth_Date}</td>
                    <td><strong>Job Title</strong><br/><br/>{profileData.Job_Title}</td>
                  </tr>
                  <tr>
                    <td><strong>Address</strong><br/><br/>{profileData.Address}</td>
                    <td><strong>Email Address</strong><br/><br/>{profileData.Email}</td>
                    <td><strong>Phone Number</strong><br/><br/>{profileData.Phone_Number}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="emergency-contact">
            <h3 className="contact-title">Emergency Contact Details</h3>
            <div className="contact-details">
              <table className="emergency-contact-table">
                <tbody>
                  <tr>
                    <td><b>First Name</b></td>
                    <td><b>Last Name</b></td>
                    <td><b>Relationship</b></td>
                    <td><b>Phone Number</b></td>
                  </tr>
                  <tr>
                    <td>{profileData.Emergency_Contact_First_Name}</td>
                    <td>{profileData.Emergency_Contact_Last_Name}</td>
                    <td>{profileData.Emergency_Contact_Relation}</td>
                    <td>{profileData.Emergency_Contact_Phone_Number}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProfilePage;
